<section id="recruitment" data-home-recruitment class="bg-emerald-50 py-6 md:py-8">
  <div class="mx-auto max-w-7xl px-4">
    <header class="max-w-3xl">
      <p class="text-xs font-semibold uppercase text-emerald-700">{{ content.badge }}</p>
      <h2 class="mt-1 text-2xl font-bold text-slate-900">{{ content.heading }}</h2>
      <p class="mt-2 text-sm text-slate-600">{{ content.intro }}</p>
    </header>

    <div class="mt-4 grid gap-4 lg:grid-cols-3">
      <div class="min-w-0 rounded-lg border border-emerald-100 bg-white p-4 lg:col-span-2">
        <h3 class="flex items-center gap-2 text-base font-semibold text-slate-900">
          <mat-icon class="text-emerald-700" svgIcon="hero:group"></mat-icon>
          {{ content.positionsHeading }}
        </h3>
        <ul class="mt-3 grid gap-2 sm:grid-cols-2">
          @for (position of content.positions; track $index) {
            <li
              data-recruitment-position
              class="flex items-center gap-3 rounded-md bg-emerald-50 px-3 py-2"
            >
              <span
                class="flex h-8 min-w-8 flex-none items-center justify-center rounded-full bg-emerald-700 px-2 text-sm font-bold text-white"
                >{{ position.count }}</span
              >
              <span class="min-w-0 text-sm text-slate-800">
                <strong class="font-semibold">{{ position.title }}</strong>
                @if (position.note) {
                  <span class="text-slate-600"> ({{ position.note }})</span>
                }
              </span>
            </li>
          }
        </ul>
      </div>

      <div class="min-w-0 rounded-lg border border-emerald-100 bg-white p-4">
        <h3 class="flex items-center gap-2 text-base font-semibold text-slate-900">
          <mat-icon class="text-emerald-700" svgIcon="hero:handshake"></mat-icon>
          {{ content.benefitsHeading }}
        </h3>
        <ul class="mt-3 grid gap-2">
          @for (benefit of content.benefits; track $index) {
            <li data-recruitment-benefit class="flex items-start gap-2 text-sm text-slate-700">
              <mat-icon class="flex-none text-emerald-700" svgIcon="hero:check_circle"></mat-icon>
              <span>{{ benefit }}</span>
            </li>
          }
        </ul>
      </div>
    </div>

    <div class="mt-4 grid gap-4 lg:grid-cols-2">
      <div class="min-w-0 rounded-lg border border-emerald-100 bg-white p-4">
        <h3 class="flex items-center gap-2 text-base font-semibold text-slate-900">
          <mat-icon class="text-emerald-700" svgIcon="hero:place"></mat-icon>
          {{ content.sitesHeading }}
        </h3>
        <ul class="mt-3 grid gap-2">
          @for (site of content.sites; track $index) {
            <li data-recruitment-site class="text-sm text-slate-700">
              <strong class="text-slate-900">{{ site.label }}:</strong> {{ site.address }}
            </li>
          }
        </ul>
      </div>

      <div class="min-w-0 rounded-lg bg-emerald-700 p-4 text-white">
        <h3 class="flex items-center gap-2 text-base font-semibold">
          <mat-icon svgIcon="hero:phone_in_talk"></mat-icon>
          {{ content.applyHeading }}
        </h3>
        <p class="mt-2 text-sm text-emerald-50">{{ content.applyText }}</p>
        <div class="mt-3 flex flex-wrap gap-3">
          @for (hotline of content.hotlines; track $index) {
            <a
              data-recruitment-hotline
              [href]="'tel:' + hotline.tel"
              class="inline-flex items-center gap-2 rounded-md bg-white px-4 py-2 text-emerald-700 hover:bg-emerald-50"
            >
              <mat-icon svgIcon="hero:phone"></mat-icon>
              <strong class="text-sm">{{ hotline.display }}</strong>
            </a>
          }
        </div>
        <p class="mt-3 text-sm font-semibold">{{ content.closing }}</p>
      </div>
    </div>
  </div>
</section>
